export const LOADING = '/loading';
export const LOGIN = '/login';
export const FORGOT_PASSWORD_EMAIL = '/forgot_password/email_confirm';
export const FORGOT_PASSWORD_RESET = '/forgot_password/reset';
export const REGISTER_CREDENTIALS = '/register/credentials';
export const REGISTER_EMAIL_CONFIRM = '/register/email_confirm';
export const REGISTER_CREATE_PROFILE = '/register/create_profile';
export const PLATFORM_HOME = '/';
export const PLATFORM_DASHBOARD = '/dashboard';
export const PLATFORM_CLUB_PREPAID_BAG_DASHBOARD = '/club/prepaid-bags';
export const PLATFORM_EDIT_PROFILE = '/user/edit';
export const PLATFORM_PURCHASE_SUCCESSFUL = '/completed-payment';

export const buildUrl = (url: string): string => {
    return "/platform" + url
}